var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundEgg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 409,
    viewBox: "0 0 417 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.097 193.625C416.097 300.561 429.657 408.127 322.72 408.127C215.784 408.127 0 300.561 0 193.625C0 86.6889 86.6889 0 193.625 0C300.561 0 416.097 86.6889 416.097 193.625Z",
    fill: "#EFF3ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEgg10);
export default __webpack_public_path__ + "static/media/background-egg-10.3ed351bb0759c76e036c5aabc8e16a68.svg";
export { ForwardRef as ReactComponent };